if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          mediaToSwitch.querySelector('button').addEventListener('click', () => this.nsRevealPhoto());
        });
        /* A TAP THAT GOT NO CLICK (owner, 3 Oct 2026, iPhone: far down, the first tap on a thumbnail did nothing and
           the second worked). On an iPhone a tap while the page is still gliding after a swipe only stops the
           glide; no click follows. A clean tap on a thumbnail (lifted where it went down, quickly) is still the
           shopper asking for that photo, so when no click has come 350 ms later, it is given one. */
        let nsTap = null;
        this.elements.thumbnails.addEventListener(
          'touchstart',
          (e) => {
            const b = e.touches.length === 1 && e.target.closest && e.target.closest('[data-target] button');
            nsTap = b ? { b, x: e.touches[0].clientX, y: e.touches[0].clientY, at: Date.now(), clicked: false } : null;
          },
          { passive: true }
        );
        this.elements.thumbnails.addEventListener(
          'click',
          (e) => {
            if (nsTap && nsTap.b.contains(e.target)) nsTap.clicked = true;
          },
          true
        );
        this.elements.thumbnails.addEventListener(
          'touchend',
          (e) => {
            const t = nsTap;
            const p = e.changedTouches && e.changedTouches[0];
            if (!t || !p || Math.abs(p.clientX - t.x) > 10 || Math.abs(p.clientY - t.y) > 10 || Date.now() - t.at > 500) return;
            setTimeout(() => {
              if (!t.clicked && nsTap === t) t.b.click();
            }, 350);
          },
          { passive: true }
        );
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      /* ON A PHONE, A THUMBNAIL TAP BRINGS ITS PHOTO INTO VIEW (owner, 3 Oct 2026, coaster set: "if the thumbnail is
         in the screen it wont push me up to see the main image"; "only keep the thumbnail pull ... because the
         reason people click a thumbnail is to see more"). Below 750px the photo sits above its thumbnails and
         scrolls away with them, so when the photo's top is cut off the page moves up until all of it shows.
         Choosing a colour, type or size does NOT move the page (owner, same day: "maybe they just select a
         variant to compare prices and then they get pulled up the whole time"); that was tried and cancelled.
         Only the header that is really on screen covers the photo: Dawn styles .section-header position: sticky
         without a top, so on these stores it scrolls away (CLAUDE.md). A header that really stays (Dawn's sticky
         header) decides where the photo's top lands.
         CUT SHORT? FINISH IT. If the page has not moved at all 450 ms later (a shopper scrolling would have moved
         it), it goes again: on the owner's iPhone the photo strip sliding sideways to the new photo at the same
         moment was one suspect for a first tap that did not move the page. */
      nsRevealPhoto() {
        if (this.mql.matches) return;
        const header = document.querySelector('.section-header');
        const hb = header ? header.getBoundingClientRect() : null;
        const coverNow = hb && hb.top < 1 ? Math.max(0, hb.bottom) : 0;
        const coverAfter = header && header.classList.contains('shopify-section-header-sticky') ? header.offsetHeight : 0;
        const photo = (this.querySelector('.product__media-list') || this).getBoundingClientRect();
        if (photo.top >= coverNow - 2) return;
        const top = Math.max(0, window.scrollY + this.getBoundingClientRect().top - coverAfter - 8);
        const from = window.scrollY;
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        clearTimeout(this.nsRevealRetry);
        this.nsRevealRetry = setTimeout(() => {
          if (Math.abs(window.scrollY - from) < 2 && Math.abs(window.scrollY - top) > 4) window.scrollTo({ top, behavior: 'smooth' });
        }, 450);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // Northsheep: do NOT vertically scroll the page when switching media.
          // The main image stays in place (sticky), so clicking a thumbnail must
          // keep the visitor exactly where they are instead of jumping upward.
          // (Phones are the exception for a thumbnail tap: see nsRevealPhoto.)
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
